// Owner item 3.1: the three account states of a registered driver or rider.
// The backend owns the definitions (precedence banned > active > inactive)
// and returns one of these keys as `account_state` on every list row and
// profile; state-counts returns how many accounts are in each.
export const ACCOUNT_STATES = Object.freeze(["active", "inactive", "banned"]);

// Values the list filter accepts (?state= and the account_state param).
export const ACCOUNT_STATE_FILTERS = Object.freeze(["all", ...ACCOUNT_STATES]);

export const ACCOUNT_STATE_COLORS = Object.freeze({
  all: "#788E98",
  active: "#2E7D32",
  inactive: "#757575",
  banned: "#C62828",
});

// The backend stores an optional ban note in blacklist_note (<= 255 chars).
export const BAN_NOTE_MAX = 255;

export function isAccountState(value) {
  return ACCOUNT_STATES.indexOf(value) !== -1;
}

// Coloured label for a DataTable formatter. Formatter output goes through
// v-html, so only a known state produces markup (its text is our own
// translation); anything else renders as an empty cell.
export function accountStateLabelHtml(state, translate) {
  if (!isAccountState(state)) return "";
  return (
    `<span style="display:inline-block;padding:2px 10px;border-radius:12px;` +
    `background-color:${ACCOUNT_STATE_COLORS[state]};color:#fff;font-size:12px;` +
    `font-weight:600;white-space:nowrap">${translate("accountState." + state)}</span>`
  );
}

// The state-counts payload ({all, active, inactive, banned, window_days}) as
// { counts, windowDays }, or null when the payload is not one (an older
// backend, the local-dev fallback stub).
export function parseStateCounts(payload) {
  if (!payload || typeof payload !== "object") return null;
  const counts = {};
  const valid = ACCOUNT_STATE_FILTERS.every((key) => {
    const raw = payload[key];
    const n = Number(raw);
    if (raw === null || raw === undefined || raw === "" || !isFinite(n) || n < 0) return false;
    counts[key] = n;
    return true;
  });
  if (!valid) return null;
  const days = Number(payload.window_days);
  return { counts, windowDays: isFinite(days) && days > 0 ? days : null };
}
